//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Formboard.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
let d=[[[0,"AxisTypeEnum",1,0],[1,"CompSel",0,"SelectNXObject",0],[0,"CustomAxis",1,"Axis",0],[1,"PathAxisSel",0,"SelectNXObject",0]],[[[],"StartDrag",{},0,0],[[],"StopDrag",{},0,0],[[],"InitializeFromComponent",{},0,0],[[],"FlipComponent",{},0,0],[["num_objects"],"CreateDatumAxis",{R_:{objects:"NXObject[]"}},0,0],[["angle"],"SetRotationAngle",{},1,0]],[]];
SPLM.Formboard.FlipComponentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Formboard.FlipComponentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Formboard.FlipComponentBuilder.AxisType = Object.freeze({
    "PathLocations" : "PathLocations", "Custom" : "Custom"});

export default SPLM;